import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Button from "../../SolarGikLib/Button";
import Dialog from "../../SolarGikLib/dialogs/Dialog";
import { narrowBlueButton } from "../../SolarGikLib/styles/ButtonsStyle";
import classes from "./OAuthResponseDialog.module.css";

type DialogType = "success" | "error";

const OAuthResponseDialog = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dialogTypeRef = useRef<DialogType>("success");
  const errorDescriptionRef = useRef<string | null>(null);

  const openDialog = (type: DialogType, errorDescription?: string | null) => {
    dialogTypeRef.current = type;
    errorDescriptionRef.current = errorDescription ?? null;
    setIsDialogOpen(true);
  };

  useEffect(() => {
    const oauthStatus = searchParams.get("oauth");
    const errorDescription = searchParams.get("error_description");
    const provider = searchParams.get("provider");

    if (oauthStatus === "success") {
      if (provider !== "SolarEdge") {
        openDialog("success");
      }
      setSearchParams({}, { replace: true });
    } else if (oauthStatus === "error") {
      openDialog("error", errorDescription);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const isSuccess = dialogTypeRef.current === "success";

  return (
    <Dialog
      title={isSuccess ? "Connection Successful" : "Connection Failed"}
      titleBorder={false}
      isOpen={isDialogOpen}
      handleClose={handleClose}
      centered
      showBackdrop
      sx={{ "& .MuiPopover-paper > div": { width: "27vw" } }}
    >
      <div className={classes.content}>
        <div className={classes.message}>
          {isSuccess ? (
            `Solargik Support will be in touch to ensure an accurate mapping between Inverter digital IDs and physical Serial Numbers (per site).
            Once this mapping is complete, you'll begin to see data in your SOMA dashboard.`
          ) : (
            <>
              {errorDescriptionRef.current ? (
                <div>{errorDescriptionRef.current}</div>
              ) : (
                <div>{`Unable to connect to your Huawei inverters. 
                Please try again or contact Solargik Support for assistance.`}</div>
              )}
            </>
          )}
        </div>
        <Button
          onClickFunc={handleClose}
          text="OK"
          style={{ ...narrowBlueButton, width: "40%", margin: "0 auto" }}
        />
      </div>
    </Dialog>
  );
};

export default OAuthResponseDialog;
